export default {
  namespaced: true,
  state:{    
    jobTitles: [],    
    jobTitleCreate: {
      modal: false,
      values: {}
    },
    jobTitleEdit: {
      modal: false,
      values: {}
    }
  },
  getters:{
    jobTitles(state){
      return state.jobTitles;
    },   
    jobTitleCreate(state) {
        return state.jobTitleCreate;
    },
    jobTitleEdit(state) {
      return state.jobTitleEdit;
    }    
  },
  mutations:{
    SET_JOB_TITLES(state, values){
      state.jobTitles = values;
    },
    SET_JOB_TITLE_CREATE_MODAL(state, value) {
      state.jobTitleCreate.modal = value;
    },
    SET_JOB_TITLE_CREATE_VALUES(state, value) {
      state.jobTitleCreate.values = value;
    },
    SET_JOB_TITLE_EDIT_MODAL(state, value) {
      state.jobTitleEdit.modal = value;
    },
    SET_JOB_TITLE_EDIT_VALUES(state, value) {
      state.jobTitleEdit.values = value;
    },
    PUSH_JOB_TITLE(state, value){
      state.jobTitles.push(value);
    },    
    SET_UPDATE_JOB_TITLE(state, values){
      var editedIndex = state.jobTitles.map(jobTitle => jobTitle.id).indexOf(values.id);      
      if (editedIndex > -1){
        Object.assign(state.jobTitles[editedIndex], values);              
      }
      return;
    },
    SPLICE_JOB_TITLE(state, value){
      let i = state.jobTitles.map(jobTitle => jobTitle.id).indexOf(value);      
      state.jobTitles.splice(i, 1);
    }
  },
  actions:{
    getJobTitles({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/job-titles').then((response) => {
          commit('SET_JOB_TITLES', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    jobTitleStore({commit}, payload) {
      const formData = new FormData();
      for(var key in payload) {
          formData.append(key, payload[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post('admin/job-titles', formData).then((response) => {
          commit('PUSH_JOB_TITLE', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    jobTitleUpdate({commit}, payload) {
      var value = payload.id;            
      return new Promise((resolve, reject) => {
        axios.put('admin/job-titles/' + value, payload).then((response) => {          
          commit('SET_UPDATE_JOB_TITLE', response.data.data);
          resolve(response);   
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    deleteJobTitle({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.delete('admin/job-titles/' + value).then((response) => {
          commit('SPLICE_JOB_TITLE', value);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });      
    },
  }
}
